
div
  i.fa.fa-spinner.fa-spin.fa-4x.card-spinner(v-if="loading")
  div(v-else)
    .row.scale(v-if="score && scale")
      .col-12
        strong Bewertung:
      .scale-box
        span.scale-score(v-bind:class='{"scale-score-tab": tab}') {{score.toFixed(1).replace(".", ",")}}/5,0
      .benchmark-box
        .benchmark-text
          b-tooltip(effect="scale" placement="left" content="Durchschnitt aller Unterhemen")
            span {{benchmark.toFixed(1).replace(".", ",")}}/5,0 Durchschnitt
        .benchmark-text
          b-tooltip(effect="scale" placement="left" content="Durchschnitt der Unternehmen mit den zufriedensten Bewerbern")
            span {{best_experience.toFixed(1).replace(".", ",")}}/5,0 BestExperience
      .col-12(v-if="subtitle")
        .subtitle {{subtitle}}
    .row(v-else-if="score")
      .col-12
        strong Bewertung:
      .scale-box
        span.percent-score {{score.toFixed(1).replace(".", ",")}}%
      .benchmark-box
        .benchmark-text
          b-tooltip(effect="scale" placement="left" content="Durchschnitt aller Unterhemen")
            i.fa.fa-lg.fa-fw.deviation-icon(:class="deviation_icon")
            span {{deviation}} als Durchschnitt
        .benchmark-text
          b-tooltip(effect="scale" placement="left" content="Durchschnitt der Unternehmen mit den zufriedensten Bewerbern")
            i.fa.fa-lg.fa-fw.deviation-icon(:class="deviation_icon_best_experience")
            span {{deviation_best_experience}} als BestExperience
      .col-12(v-if="subtitle")
        .subtitle {{subtitle}}
    .row(v-else)
      .col-12
        br
        .subtitle Keine Daten
